import { NgModule } from '@angular/core';

import { DownloadService } from './download.service';

@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [DownloadService],
})
export class DownloadServiceModule {}
